// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkBoxField_checkboxWrapper__vTqYf","checkedImg":"checkBoxField_checkedImg__98psx","testL":"checkBoxField_testL__umAJS"};